import axios, { AxiosResponse } from 'axios';
const url =
  process.env.REACT_APP_BACK_URL || process.env.REACT_APP_BACK_URL_DEV;
class FaqService {
  getFaq(search?: string): Promise<AxiosResponse> {
    return axios.get(`${url}/faqs`, { params: { search } });
  }
}
export default new FaqService();
